<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Senarai Terimaan Cek">

             <w-flex justify-space-between class="mb4">
                <div class="xs4">
                    <z-input 
                          label="Tarikh Transaksi" 
                          name="tarikh_dari" 
                          v-model="cari.tarikh_dari" 
                           type="date"/>
                </div>
                <div class="xs4">
                    <z-input 
                          label="Tarikh Hingga" 
                          name="tarikh_hingga" 
                          v-model="cari.tarikh_hingga" 
                           type="date"/>
                </div>
                 <div class="xs4"> 
                    <w-input v-model="cari.no_cek" label="No. Cek / Bank Draf / Wang Pos" /> 
                </div>
                
            </w-flex>
            <w-flex justify-space-between class="mb4">
                    <div class="xs4">
                      <z-lookup label="Status" name="status" 
                        :options="status" :sort="false" :cache="false" v-model="cari.status" />
                  </div>
                  <div class="xs4">
                     <z-lookup :url="service_utiliti +'lookup/cara_bayar_cek'"
                    :sort="false"
                    :cache="false"
                    v-model="cari.lkp_cara_bayaran_id"
                    label="Cara Bayaran "
                />
                </div>

                <div class="xs4">
                </div>
              </w-flex>

             <div class="mt2 text-right"> 
                <w-button bg-color="success" class="mr3" @click="cetakSenarai" :loading="cetak.loading">
                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak Senarai
                </w-button>
                <w-button class="ml1" v-on:click="reset()" bg-color="warning" :loading="cari.loading">
                    <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="search()" :loading="cari.loading">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
            </div>
            <br>

           
            <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>
            <center v-if="cari.loading"><w-progress class="ma1" circle></w-progress></center>
            <center v-if="cetak.loading"><w-progress class="ma1" circle></w-progress></center>

            <z-table ref="tbluser" title="Senarai : Terimaan Cek" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
               <template #item-cell.amaun_cek="{ item, label, header, index }">
                    {{$zutil.currency(item.amaun_cek)}}
                </template>
                  <template #item-cell.status="{ item, label, header, index }">
                    <template v-if="item.status== 0">
                        Cek Belum Jelas
                    </template>
                    <template v-else-if="item.status== 1">
                        Cek Sudah Jelas
                    </template>
                    <template v-else-if="item.status== 2">
                        Cek Tak Laku
                    </template> 
                    <template v-else-if="item.status== 3">
                        Permohonan Cek Tak Laku
                    </template>
                    <template v-else>
                        
                    </template>
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                  <w-flex class="flex justify-center">
                    <inertia-link :href='$route("kutipan.terimaan_cek.show",item.id)'>
                        <w-tooltip top>
                           <template #activator="{ on }">
                             <w-icon v-on="on" >
                               fal fa-file
                             </w-icon>
                           </template>
                           Papar
                         </w-tooltip>
                        </inertia-link>
                  </w-flex>
                </template>
            </z-table>

        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_kutipan +'terimaan_cek',
        reload: true,
        loading: true,
        cari : {
          loading: false,
        },
        status: [
                // {
                //     value: 0,
                //     label: "BELUM JELAS",
                // },
                {
                    value: 1,
                    label: "CEK SUDAH JELAS"
                },
                {
                    value: 2,
                    label: "CEK TAK LAKU",
                },
                {
                    value: 3,
                    label: "PERMOHONAN CEK TAK LAKU"
                },
            ],
        cetak : {
          loading: false,
        },
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Kutipan', route: '/kutipan' },
            { label: 'Senarai Cek', route: 'kutipan' }
          ],

          cari : {lkp_cara_bayaran_id:'', tarikh_dari: '' , tarikh_hingga: '', no_cek: '', status: '', proses : 0},
           
        }
         
  },
  methods: {
    search() {

      this.cari.loading = true

            var url = window.route('kutipan.terimaan_cek.index')+'?lkp_cara_bayaran_id='+this.cari.lkp_cara_bayaran_id+'&tarikh_dari='+this.cari.tarikh_dari+'&no_cek='+this.cari.no_cek+'&status='+this.cari.status+'&tarikh_hingga='+this.cari.tarikh_hingga+'&proses=1';
            this.$inertia.visit(url, { preserveScroll : true})
           
          },
          // reset(){
          //   this.cari ={lkp_cara_bayaran_id:'', tarikh_bayar: '' , no_cek: '', proses : 0}
          //   var url = window.route('kutipan.terimaan_cek.index')+'?lkp_cara_bayaran_id='+this.cari.lkp_cara_bayaran_id+'&tarikh_bayar='+this.cari.tarikh_bayar+'&no_cek='+this.cari.no_cek+'&status='+this.cari.status+'&proses=0';
          //   this.$inertia.visit(url, { preserveScroll : true})
          // },

          reset(){
              
                this.cari ={lkp_cara_bayaran_id:'', tarikh_dari: '' , tarikh_hingga: '' , no_cek: '', proses : 0}
                    this.search()
            },

        cetakSenarai() {

      this.cetak.loading = true
                window.location.href = this.service_kutipan+'terimaan_cek/cetaksenarai/'+'cetak'+'?lkp_cara_bayaran_id='+this.cari.lkp_cara_bayaran_id+'&tarikh_dari='+this.cari.tarikh_dari+'&no_cek='+this.cari.no_cek+'&status='+this.cari.status+'&tarikh_hingga='+this.cari.tarikh_hingga+'&jabatan_id='+this.$page.props.auth.user.jabatan_id+'&proses=1', {preserveScroll:true};
            // window.location.href = this.service_kutipan+'resit/senarai/';
        },

        // load() {
        //     // this.loading = true
        //     this.$zcomm.get(this.service_kutipan +'terimaan_cek'+window.location.search)
        //     .then(res => {
        //       })
        //     .finally(() => {

        //         this.loading = false
        //         });
        // },
        
  },
  watch: {
    
  },
  mounted() {
    // this.load();
    // override default setting
    this.dialog.width = 900
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari && this.cari.no_cek && this.cari.no_cek == 'undefined'){
      this.cari.no_cek = ''
    }
     if(this.cari && this.cari.lkp_cara_bayaran_id && this.cari.lkp_cara_bayaran_id == 'undefined'){
      this.cari.lkp_cara_bayaran_id = ''
    }
     if(this.cari && this.cari.tarikh_dari && this.cari.tarikh_dari == 'undefined'){
      this.cari.tarikh_dari = ''
    }
    if(this.cari && this.cari.tarikh_hingga && this.cari.tarikh_hingga == 'undefined'){
      this.cari.tarikh_hingga = ''
    }
    if(this.cari && this.cari.status && this.cari.status == 'undefined'){
      this.cari.status = ''
    }
   
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>